<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入角色名进行检索" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('qxgl_jslb_xz')">
            <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="ID" align="center" prop="id" />
            <el-table-column label="角色名" align="center" prop="title" />
            <el-table-column label="最后修改时间" align="center" prop="update_time" />
            <el-table-column v-if="permission('qxgl_jslb_bj') || permission('qxgl_jslb_sc')" label="操作" align="center" width="100">
                <template slot-scope="{ row }">
                    <el-button v-if="permission('qxgl_jslb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                    <el-button v-if="permission('qxgl_jslb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/auth/role";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "角色",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$router.push({ path: "/auth/role/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/auth/role/form", query: { uuid: row.id } });
        },
    },
};
</script>
